export const pxToRem = (targetPx: number, rootPx = 16) =>
  `${targetPx / rootPx}rem`;

export const remToPx = (targetRem: string | number, rootPx = 16) =>
  `${parseFloat(`${targetRem}`) * rootPx}px`;
